import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
const testimonials = [{
  quote: 'Antes tardaba 40 minutos en armar el plan de cada paciente nuevo. Con el NutriPro Kit lo tengo listo en 10. Un cambio total en mi consulta.',
  name: 'Valentina R.',
  title: 'Lic. en Nutrición',
  city: 'Córdoba',
  initials: 'VR'
}, {
  quote: 'Recién me recibí y no sabía cómo organizar nada. Este kit me dio la estructura profesional que necesitaba desde el primer día.',
  name: 'Martín G.',
  title: 'Nutricionista',
  city: 'Rosario',
  initials: 'MG'
}, {
  quote: 'Los gráficos de progreso que le muestro a cada paciente generaron un cambio enorme en la adherencia al tratamiento. Lo recomiendo.',
  name: 'Florencia M.',
  title: 'Lic. en Nutrición',
  city: 'CABA',
  initials: 'FM'
}];
export function Testimonials() {
  return <section className="py-12 bg-white" data-id="element-272">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-273">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-274">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gray-50 rounded-2xl p-5 relative border border-gray-100 flex flex-col" data-id="element-275">
              <Quote className="absolute top-4 right-4 text-gray-200" size={28} data-id="element-276" />

              <div className="flex text-yellow-400 mb-3" data-id="element-277">
                {[...Array(5)].map((_, starIdx) => <Star key={starIdx} size={15} fill="currentColor" data-id="element-278" />)}
              </div>

              <p className="text-gray-700 italic text-sm mb-4 relative z-10 leading-relaxed flex-grow" data-id="element-279">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-3 mt-auto" data-id="element-280">
                <div className="w-10 h-10 rounded-full bg-nutri-medium text-white flex items-center justify-center font-bold text-base" data-id="element-281">
                  {t.initials}
                </div>
                <div data-id="element-282">
                  <h4 className="font-bold text-gray-900 text-sm" data-id="element-283">{t.name}</h4>
                  <p className="text-xs text-gray-500" data-id="element-284">
                    {t.title}, {t.city}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}